import React from 'react';

const ApolloClientContext = React.createContext();

export default ApolloClientContext;
